<template>
  <div class="app-container workbench" v-loading="loading">
    <div class="page-header">
      <div class="page-header__left">
        <p class="page-header__meta">
          当前账号：{{ accountLabel }}（供应商/委外商），数据来自我司业务系统，更新时间：{{ updateTime }}
        </p>
        <h2 class="page-header__title">供应商协同工作台</h2>
      </div>
      <div class="page-header__actions">
        <!-- <el-button
          size="small"
          icon="el-icon-refresh"
          :loading="loading"
          @click="refreshStat"
        >
          刷新待办
        </el-button>
        <el-button size="small" icon="el-icon-printer" @click="goPrint">
          打印中心
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="goCreateDelivery"
        >
          发起出货
        </el-button> -->
      </div>
    </div>

    <div class="stat-panel">
      <el-row :gutter="16">
        <el-col
          v-for="item in statCards"
          :key="item.key"
          :xs="24"
          :sm="12"
          :md="6"
        >
          <div
            class="stat-card"
            :class="'stat-card--' + item.tone"
            @click="item.onClick && item.onClick()"
          >
            <div class="stat-card__top">
              <span class="stat-card__title">{{ item.title }}</span>
              <span class="stat-card__badge">{{ item.badge }}</span>
            </div>
            <div class="stat-card__count" :style="{ color: item.color }">
              {{ item.count }}
            </div>
            <div class="stat-card__desc">{{ item.desc }}</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="workbench-body">
      <div class="workbench-body__main">
        <div class="todo-panel">
          <div class="todo-panel__header">
            <h3 class="todo-panel__title">今日关键待办</h3>
            <span class="todo-panel__count">共 {{ todoQuery.total }} 项</span>
          </div>
          <myHtml
            v-loading="todoLoading"
            :height="400"
            :id="'workbench_todo'"
            :columnType="'columnIndex'"
            :list="todoList"
            :titleList="todoTitleList"
            :tableBtnList="[]"
            :keyData="todoKeyData"
            @cellClickEvent="onTodoCellClick"
            ref="todoTable"
          />
          <pagination
            :total="todoQuery.total"
            :page.sync="todoQuery.pageNum"
            :limit.sync="todoQuery.pageSize"
            :page-sizes="[10, 20, 50]"
            :auto-scroll="false"
            layout="total, sizes, prev, pager, next, jumper"
            class="todo-pagination"
            @pagination="loadTodoList"
          />
        </div>
      </div>
      <aside class="reminder-board">
        <div class="reminder-board__header">
          <div>
            <h3 class="reminder-board__title">我的协同提醒</h3>
            <p class="reminder-board__sub">来自我司的单据与消息</p>
          </div>
          <button type="button" class="reminder-board__latest" @click="refreshStat">
            最新
          </button>
        </div>

        <div
          v-for="item in reminderEntries"
          :key="item.key"
          class="reminder-entry"
          @click="item.onClick && item.onClick()"
        >
          <div class="reminder-entry__title">{{ item.title }}</div>
          <div class="reminder-entry__desc">{{ item.desc }}</div>
        </div>

        <div class="reminder-exception">
          <div class="reminder-exception__title">异常提醒</div>
          <div
            v-if="!exceptionReminders.length"
            class="reminder-exception__empty"
          >
            暂无异常提醒
          </div>
          <div
            v-for="(item, index) in exceptionReminders"
            :key="item.key || index"
            class="reminder-alert"
            @click="onExceptionClick(item)"
          >
            <div class="reminder-alert__title">{{ item.displayTitle }}</div>
            <div class="reminder-alert__desc">{{ item.displayDesc }}</div>
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import {
  cooperativeDashboard_getHomeStat,
  cooperativeDashboard_getReminderBoard,
  cooperativeDashboard_listTodo,
} from '@/api/myController/outsourcing'
import { formatInventoryQtyLabel } from '@/utils/outsourcingWarehouseSummary'

function toNum(value) {
  const num = Number(value)
  return Number.isNaN(num) ? 0 : num
}

function formatStatQty(value) {
  return formatInventoryQtyLabel(toNum(value))
}

function buildPrintTemplateDesc(board) {
  const names = []
  if (board.printDeliveryEnabled) names.push('出货单')
  if (board.printLabelEnabled) names.push('标签')
  if (board.printReceiveEnabled) names.push('收料单')
  if (!names.length) return '暂无已启用的打印模板'
  return `${names.join('、')}模板已启用`
}

function resolveTodoRoute(row = {}) {
  const actionCode = String(row.actionCode || '').toUpperCase()
  const taskType = String(row.taskType || '').toUpperCase()
  if (
    actionCode.includes('STATEMENT') ||
    taskType.includes('STATEMENT')
  ) {
    return 'outsourcingProduct_statement'
  }
  if (
    actionCode.includes('DELIVERY') ||
    actionCode.includes('FINISH') ||
    taskType.includes('DELIVERY') ||
    taskType.includes('FINISH')
  ) {
    return 'outsourcingProduct_finish'
  }
  if (
    actionCode.includes('ORDER') ||
    taskType.includes('ORDER')
  ) {
    return 'outsourcingProduct_order'
  }
  if (
    actionCode.includes('RECEIVE') ||
    taskType.includes('RECEIVE')
  ) {
    return 'outsourcingProduct_materials'
  }
  return 'outsourcingProduct_materials'
}

function formatTodoQuantity(row = {}) {
  if (row.quantity === null || row.quantity === undefined || row.quantity === '') {
    return '-'
  }
  const qty = formatStatQty(row.quantity)
  return row.unitName ? `${qty} ${row.unitName}` : qty
}

function normalizeTodoRow(row = {}, index = 0) {
  return {
    ...row,
    _rowKey: `${row.taskType || 'TODO'}_${row.bizDocId || index}`,
    materialText: row.materialText || '-',
    quantityText: formatTodoQuantity(row),
    statusName: row.statusName || '-',
    actionName: row.actionName || '-',
  }
}

export default {
  name: 'workbench',
  data() {
    return {
      loading: false,
      updateTime: '',
      homeStat: {},
      reminderBoard: {},
      todoList: [],
      todoLoading: false,
      todoQuery: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      todoKeyData: ['_rowKey'],
      todoTitleList: [
        {
          id: 1,
          name: '任务类型',
          value: 'taskTypeName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 110,
        },
        {
          id: 2,
          name: '来源单号',
          value: 'sourceDocNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          color: '#409eff',
          width: 150,
        },
        {
          id: 3,
          name: '物料',
          value: 'materialText',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
        },
        {
          id: 4,
          name: '数量/金额',
          value: 'quantityText',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 120,
        },
        {
          id: 5,
          name: '状态',
          value: 'statusName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 100,
        },
        {
          id: 6,
          name: '操作',
          value: 'actionName',
          fixedState: 'right',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          color: '#409eff',
          width: 100,
        },
      ],
    }
  },
  computed: {
    accountLabel() {
      const user = this.getUserInfo || {}
      return (
        user.supplierName ||
        user.showName ||
        user.loginName ||
        '当前供应商'
      )
    },
    statCards() {
      const stat = this.homeStat || {}
      const pendingReceive = toNum(stat.todayPendingReceiveDocCount)
      const partialReceive = toNum(stat.todayPartialReceiveDocCount)
      const pendingDeliveryQty = formatStatQty(stat.weekPendingDeliveryQuantity)
      const inventoryTotal = formatStatQty(stat.outsourcingInventoryTotalQuantity)
      const productInventory = formatStatQty(stat.productOutsourcingInventoryQuantity)
      const processInventory = formatStatQty(stat.processOutsourcingInventoryQuantity)
      const totalStatement = toNum(stat.totalStatementCount)
      const pendingStatement = toNum(stat.pendingConfirmStatementCount)
      const objectedStatement = toNum(stat.objectedStatementCount)

      return [
        {
          key: 'pendingReceive',
          title: '待收料确认',
          badge: '今日',
          count: pendingReceive,
          color: '#e6a23c',
          tone: 'warning',
          desc:
            partialReceive > 0
              ? `含 ${partialReceive} 单部分收料待说明`
              : '本厂已发料，待委外商确认收料',
          onClick: () => this.goMaterials(),
        },
        {
          key: 'pendingDelivery',
          title: '待出货任务',
          badge: '本周',
          count: pendingDeliveryQty,
          color: '#67c23a',
          tone: 'success',
          desc: '本周待出货数量（未完工量合计）',
          onClick: () => this.goFinish(),
        },
        {
          key: 'inventory',
          title: '委外库存总量',
          badge: '授权范围',
          count: inventoryTotal,
          color: '#409eff',
          tone: 'info',
          desc: `产品委外 ${productInventory}，工序委外 ${processInventory}`,
          onClick: () => this.goWarehouse(),
        },
        {
          key: 'statement',
          title: '待确认账单',
          badge: '对账',
          count: pendingStatement,
          color: '#f56c6c',
          tone: 'danger',
          desc: `账单共 ${totalStatement} 单，有异议 ${objectedStatement} 单`,
          onClick: () => this.goStatement(),
        },
      ]
    },
    reminderEntries() {
      const board = this.reminderBoard || {}
      const orderCount = toNum(board.newOutsourcingOrderPendingCount)
      const skuCount = toNum(board.inventorySkuCount)
      const exceptionBatchCount = toNum(board.receiveExceptionBatchCount)

      return [
        {
          key: 'newOrder',
          title: '新委外订单',
          desc: `${orderCount} 单待查看，包含工艺、数量和交期要求`,
          onClick: () => this.goOrder(),
        },
        {
          key: 'inventory',
          title: '委外库存',
          desc: `${skuCount} 个SKU可查询`,
          onClick: () => this.goWarehouse(),
        },
        {
          key: 'print',
          title: '打印模板',
          desc: buildPrintTemplateDesc(board),
          onClick: () => this.goPrint(),
        },
      ]
    },
    exceptionReminders() {
      const board = this.reminderBoard || {}
      const receiveList = Array.isArray(board.receiveExceptionReminders)
        ? board.receiveExceptionReminders
        : []
      const statementList = Array.isArray(board.objectedStatementReminders)
        ? board.objectedStatementReminders
        : []

      return [
        ...receiveList.map((item, index) => ({
          ...item,
          key: `receive-${item.bizDocId || index}`,
          displayTitle: item.exceptionType || item.title || '收料异常',
          displayDesc: [item.bizDocNumber, item.remark].filter(Boolean).join(' '),
          jumpType: 'receive',
        })),
        ...statementList.map((item, index) => ({
          ...item,
          key: `statement-${item.bizDocId || index}`,
          displayTitle: item.exceptionType || item.title || '有异议账单',
          displayDesc: [item.bizDocNumber, item.remark].filter(Boolean).join(' '),
          jumpType: 'statement',
        })),
      ]
    },
  },
  mounted() {
    this.refreshStat()
  },
  methods: {
    formatUpdateTime() {
      const d = new Date()
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
        d.getHours()
      )}:${pad(d.getMinutes())}`
    },
    refreshStat() {
      this.loading = true
      this.todoQuery.pageNum = 1
      Promise.all([
        cooperativeDashboard_getHomeStat({})
          .then((res) => {
            this.homeStat = (res.data && res.data.data) || {}
          })
          .catch(() => {
            this.homeStat = {}
          }),
        cooperativeDashboard_getReminderBoard({})
          .then((res) => {
            this.reminderBoard = (res.data && res.data.data) || {}
          })
          .catch(() => {
            this.reminderBoard = {}
          }),
        this.loadTodoList(false),
      ])
        .then(() => {
          this.updateTime = this.formatUpdateTime()
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadTodoList(showTodoLoading = true) {
      if (showTodoLoading) {
        this.todoLoading = true
      }
      return cooperativeDashboard_listTodo({
        pageParam: {
          pageNum: this.todoQuery.pageNum,
          pageSize: this.todoQuery.pageSize,
        },
      })
        .then((res) => {
          const data = (res.data && res.data.data) || {}
          const dataList = Array.isArray(data.dataList) ? data.dataList : []
          this.todoList = dataList.map((row, index) => normalizeTodoRow(row, index))
          this.todoQuery.total = toNum(data.totalCount) || this.todoList.length
        })
        .catch(() => {
          this.todoList = []
          this.todoQuery.total = 0
        })
        .finally(() => {
          this.todoLoading = false
        })
    },
    onTodoCellClick(row, column) {
      const field = column && (column.field || column.property)
      if (field === 'sourceDocNumber' || field === 'actionName') {
        this.onTodoAction(row)
      }
    },
    onTodoAction(row) {
      const routeName = resolveTodoRoute(row)
      this.$router.push({ name: routeName }).catch(() => {})
    },
    onExceptionClick(item) {
      if (item.jumpType === 'statement') {
        this.goStatement()
        return
      }
      this.goMaterials()
    },
    goMaterials() {
      this.$router.push({ name: 'outsourcingProduct_materials' })
    },
    goFinish() {
      this.$router.push({ name: 'outsourcingProduct_finish' })
    },
    goWarehouse() {
      this.$router.push({ name: 'outsourcingProduct_warehouseOverview' })
    },
    goStatement() {
      this.$router.push({ name: 'outsourcingProduct_statement' })
    },
    goOrder() {
      this.$router.push({ name: 'outsourcingProduct_order' })
    },
    goPrint() {
      this.$router.push({ name: 'print_printSystem' }).catch(() => {
        this.$message.info('请从菜单进入打印模板')
      })
    },
    goCreateDelivery() {
      this.$router.push({ name: 'outsourcingProduct_finish' })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.workbench {
  padding-bottom: 24px;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.page-header__meta {
  margin: 0 0 8px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.page-header__title {
  margin: 0;
  color: #303133;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.page-header__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.stat-panel {
  margin-bottom: 8px;
}

.stat-card {
  min-height: 126px;
  margin-bottom: 16px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  }
}

.stat-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.stat-card__title {
  color: #606266;
  font-size: 14px;
  font-weight: 600;
}

.stat-card__badge {
  padding: 2px 8px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  background: #f5f7fa;
  border-radius: 10px;
}

.stat-card__count {
  margin-bottom: 10px;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.stat-card__desc {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.stat-card--warning {
  background: linear-gradient(180deg, #fffaf0 0%, #ffffff 72%);
}

.stat-card--success {
  background: linear-gradient(180deg, #f3fbf6 0%, #ffffff 72%);
}

.stat-card--info {
  background: linear-gradient(180deg, #f5f9ff 0%, #ffffff 72%);
}

.stat-card--danger {
  background: linear-gradient(180deg, #fff5f5 0%, #ffffff 72%);
}

.workbench-body {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.workbench-body__main {
  flex: 1;
  min-width: 0;
}

.todo-panel {
  padding: 16px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
}

.todo-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.todo-panel__title {
  margin: 0;
  color: #303133;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
}

.todo-panel__count {
  color: #909399;
  font-size: 12px;
}

.todo-pagination {
  margin-top: 12px;
  padding: 0;
  text-align: right;
}

.reminder-board {
  width: 360px;
  height: 530px;
  flex-shrink: 0;
  padding: 16px;
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 10px;
}

.reminder-board__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.reminder-board__title {
  margin: 0;
  color: #303133;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
}

.reminder-board__sub {
  margin: 4px 0 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

.reminder-board__latest {
  padding: 0;
  border: 0;
  background: transparent;
  color: #409eff;
  font-size: 13px;
  line-height: 22px;
  cursor: pointer;
}

.reminder-entry {
  margin-bottom: 10px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #c0c4cc;
  }
}

.reminder-entry__title {
  margin-bottom: 6px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.reminder-entry__desc {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.reminder-exception {
  margin-top: 14px;
}

.reminder-exception__title {
  margin-bottom: 10px;
  color: #303133;
  font-size: 14px;
  font-weight: 700;
}

.reminder-exception__empty {
  padding: 12px 14px;
  color: #909399;
  font-size: 12px;
  background: #fff;
  border: 1px dashed #e4e7ed;
  border-radius: 8px;
}

.reminder-alert {
  margin-bottom: 10px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #c0c4cc;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.reminder-alert__title {
  margin-bottom: 6px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.reminder-alert__desc {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  word-break: break-all;
}

@media (max-width: 992px) {
  .workbench-body {
    flex-direction: column;
  }

  .reminder-board {
    width: 100%;
  }
}
</style>
